{
  "ad_break_overlay__ad_counter": "Annons {adSequenceIndex} av {adBreakTotalAds}",
  "ad_break_overlay__ad_starts_in": {
    "one": "Annons visas om {number} sekund",
    "other": "Annons visas om {number} sekunder"
  },
  "ad_break_overlay__video_starts_in": {
    "one": "Annons. Videon börjar om {number} sekund.",
    "other": "Annons. Videon börjar om {number} sekunder."
  },
  "ad_break_overlay__visit_advertiser": "Besök annonsör",
  "ad_indicator__ad": "Annons",
  "channels": "Kanaler",
  "chromecast__commercial": "Spelar reklam på Chromecast",
  "chromecast__error": "Chromecast-fel: {error}",
  "chromecast__loading": "Laddar",
  "chromecast__playing": "Spelar på Chromecast",
  "controlls__jump_to_live_title": "Titta live",
  "controlls__pause_title": "Paus",
  "controlls__start_over_title": "Starta om",
  "controlls__voting_title": "Röstningsläge",
  "cta__cast__close": "Close",
  "cta__push_next__see_credits": "See credits",
  "error__expired_vod": "%1$s is no longer available.\\nIt was removed %2$s",
  "error__playback_drm": "An error occurred (DRM)",
  "error__playback_hdmi": "An error occurred (HDMI)",
  "error__subscription": "Change your subscription to get access to this content.",
  "error__subscription_title": "Your subscription does not give you access to this video",
  "error__user_denied": "You do not have the right to watch this video",
  "error_message__ad_blocker__header": "Har du en annonsblockerare igång?",
  "error_message__ad_blocker__message": "För att ta del av vårt innehåll behöver du avaktivera din annonsblockerare och ladda om sidan.",
  "error_message__problem_general": "Något gick fel",
  "error_message__stream_limit__button_back": "Tillbaka",
  "error_message__stream_limit__button_close": "Avsluta",
  "error_message__stream_limit__button_details_about_streaming": "Detaljer om din uppspelning",
  "error_message__stream_limit__button_details_log_out_instructions": "Behöver du logga ut dig från andra enheter än denna kan du gå in på tv4play.se/installningar",
  "error_message__stream_limit__button_details_log_out_instructions_short": "Du kan logga ut ifrån andra enheter på tv4play.se/installningar",
  "error_message__stream_limit_details__header_playing_now": "Just nu spelas: ",
  "error_message__stream_limit_single_stream__header": "{eventTitle} spelas redan på en annan enhet",
  "error_message__stream_limit_single_stream__header_this_stream": "Den här strömmen",
  "error_message__stream_limit_single_stream__message": "Det här evenemanget går endast att se på en enhet i taget. Vill du se på den här enheten måste strömmen på din andra enhet upphöra.",
  "error_message__stream_limit_single_stream__message_shortened": "Det här evenemanget går endast att se på en enhet i taget.",
  "error_message__stream_limit_stream_quota__header": "Ditt konto används på för många enheter just nu",
  "error_message__stream_limit_stream_quota__message": "Det går endast att spela upp innehåll på maximalt två enheter samtidigt per konto. Vill du spela upp något på den här enheten måste en av strömmarna på din andra enhet upphöra först.",
  "error_message__stream_limit_stream_quota__message_shortened": "Maximalt antal strömmar används",
  "inactive__continue_watching_no": "Nej, avbryt",
  "inactive__continue_watching_question": "Vill du fortsätta titta?",
  "inactive__continue_watching_yes": "Ja fortsätt",
  "language__audio": "Ljud",
  "language__da": "Danska",
  "language__de": "Tyska",
  "language__default": "Originalversion",
  "language__dub": "Dubbat",
  "language__dubbing": "Dubbat",
  "language__el": "Grekiska",
  "language__en": "Engelska",
  "language__es": "Spanska",
  "language__fi": "Finska",
  "language__fr": "Franska",
  "language__it": "Italienska",
  "language__live": "Live captioning",
  "language__nb": "Norskt bokmål",
  "language__nl": "Nederländska",
  "language__no": "Norska",
  "language__no_subtitles": "Inga undertexter",
  "language__off": "Av",
  "language__pt": "Portugisiska",
  "language__qaa": "Utan kommentator",
  "language__qaf": "Uppläst undertext (Fi)",
  "language__qag": "Direkttextning",
  "language__qai": "Svenska (AI-genererad)",
  "language__qas": "Uppläst undertext (Sv)",
  "language__qol": "Original",
  "language__subtitle": "Undertext",
  "language__subtitles": "Undertexter",
  "language__subtitles_and_audio": "Undertexter och Ljud",
  "language__subtitles_off": "Av",
  "language__subtitles_size": "Storlek på text",
  "language__sv": "Svenska",
  "language__zh": "Kinesiska",
  "language_ar": "Arabiska",
  "language_bg": "Bulgariska",
  "language_cs": "Tjeckiska",
  "language_dk": "Danska",
  "language_el": "Grekiska",
  "language_et": "Estniska",
  "language_fa": "Persiska",
  "language_he": "Hebreiska",
  "language_hi": "Hindi",
  "language_hr": "Kroatiska",
  "language_hu": "Ungerska",
  "language_is": "Isländska",
  "language_it": "Italienska",
  "language_ja": "Japanska",
  "language_lt": "Litauiska",
  "language_lv": "Lettiska",
  "language_mk": "Makedonska",
  "language_no": "Norska",
  "language_off": "Av",
  "language_pl": "Polska",
  "language_pt": "Portugisiska",
  "language_qaa": "Utan kommentering",
  "language_qad": "Arenaljud",
  "language_qd": "Arenaljud",
  "language_qhi": "Nedsatt hörsel",
  "language_qvi": "Nedsatt syn",
  "language_ro": "Rumänska",
  "language_role_direct": "Direkttextning",
  "language_ru": "Ryska",
  "language_sk": "Slovakiska",
  "language_sl": "Slovenska",
  "language_sq": "Albanska",
  "language_sr": "Serbiska",
  "language_title": "Språk",
  "language_tr": "Turkiska",
  "language_uk": "Ukrainska",
  "language_zh": "Kinesiska",
  "new__channels_open_table": "Öppna tablån",
  "new__channels_overlay_title": "Kanaler",
  "playback_speed_header": "Uppspelningshastighet",
  "player__a11y__announcement_hiding_controls": "Döljer kontroller",
  "player__a11y__announcement_hours": "{hours} timmar",
  "player__a11y__announcement_live": "Live",
  "player__a11y__announcement_minutes": "{minutes} minuter",
  "player__a11y__announcement_parental_rating_age": "Åldersgräns {ageLimit}.",
  "player__a11y__announcement_parental_rating_anxiety": "ångest",
  "player__a11y__announcement_parental_rating_drugs": "droger",
  "player__a11y__announcement_parental_rating_reasons": "Anledningar: {reasons}.",
  "player__a11y__announcement_parental_rating_sex": "sex",
  "player__a11y__announcement_parental_rating_violence": "våld",
  "player__a11y__announcement_paused": "Pausad",
  "player__a11y__announcement_playing": "Spelar",
  "player__a11y__announcement_seconds": "{seconds} sekunder",
  "player__a11y__announcement_shorts_next": "Spelar nästa klipp",
  "player__a11y__announcement_shorts_next_on_last_short": "Detta är det sista klippet",
  "player__a11y__announcement_shorts_previous": "Spelar föregående klipp",
  "player__a11y__announcement_shorts_previous_on_first_short": "Detta är det första klippet",
  "player__a11y__announcement_showing_controls": "Visar kontroller",
  "player__a11y__announcement_skip_back_live": "Hoppar bakåt {seconds} sekunder efter live",
  "player__a11y__announcement_skipping_ahead": "Hoppar fram {seconds} sekunder",
  "player__a11y__announcement_skipping_back": "Hoppar bakåt {seconds} sekunder",
  "player__a11y__hover_label_airplay_button": "Airplay",
  "player__a11y__hover_label_back_button": "Tillbaka",
  "player__a11y__hover_label_enter_fullscreen_button": "Öppna helskärmsläge",
  "player__a11y__hover_label_exit_fullscreen_button": "Stäng helskärmsläge",
  "player__a11y__hover_label_go_to_live_button": "Gå till live",
  "player__a11y__hover_label_go_to_startover_button": "Se från början",
  "player__a11y__hover_label_language_menu_button": "Undertexter och ljud",
  "player__a11y__hover_label_mute_button": "Ljud av",
  "player__a11y__hover_label_pause_button": "Pausa",
  "player__a11y__hover_label_play_button": "Spela",
  "player__a11y__hover_label_playback_speed_button": "Uppspelningshastighet",
  "player__a11y__hover_label_seek_back_button": "Hoppa bakåt {seconds}s",
  "player__a11y__hover_label_seek_forward_button": "Hoppa fram {seconds}s",
  "player__a11y__hover_label_share_button": "Dela",
  "player__a11y__hover_label_start_cast_button": "Starta Chromecast",
  "player__a11y__hover_label_stop_cast_button": "Sluta casta",
  "player__a11y__hover_label_unmute_button": "Ljud på",
  "player__a11y__hover_label_voting_button": "Rösta",
  "player__a11y__label_all_program_genre_filter": "Genrefilter",
  "player__a11y__label_all_program_letter_filter": "Bokstavsfilter",
  "player__a11y__label_button": "Knapp",
  "player__a11y__label_chromecast": "Chromecast",
  "player__a11y__label_chromecast_active": "Chromecast aktiv",
  "player__a11y__label_chromecast_inactive": "Chromecast inaktiv",
  "player__a11y__label_close_channels": "Stäng kanaler",
  "player__a11y__label_close_language_menu": "Stäng undertexter och ljud",
  "player__a11y__label_close_pause_ad": "Stäng pausannons",
  "player__a11y__label_close_player": "Stäng spelare",
  "player__a11y__label_hide_controls": "Dölj kontroller",
  "player__a11y__label_language_selected": "{language} vald",
  "player__a11y__label_packet_pre_label": "Paket",
  "player__a11y__label_pause": "Pausa",
  "player__a11y__label_resume": "Fortsätt spela",
  "player__a11y__label_rotate_screen": "Rotera skärm",
  "player__a11y__label_shorts_next": "Nästa klipp",
  "player__a11y__label_shorts_previous": "Föregående klipp",
  "player__a11y__label_show_controls": "Visa kontroller",
  "player__a11y__label_skip_ahead": "Hoppa fram {seconds} sekunder",
  "player__a11y__label_skip_back": "Hoppa bakåt {seconds} sekunder",
  "player__a11y__playback_speed_double": "Dubbel hastighet",
  "player__a11y__playback_speed_faster": "Snabbare",
  "player__a11y__playback_speed_half": "Halv hastighet",
  "player__a11y__playback_speed_normal": "Normal hastighet",
  "player__a11y__playback_speed_selected": "{selectedSpeed} vald",
  "player__a11y__playback_speed_slightly_faster": "Lite snabbare",
  "player__a11y__voice_over_airplay_button": "Airplay",
  "player__a11y__voice_over_back_button": "Tillbaka",
  "player__a11y__voice_over_close_button": "Stäng",
  "player__a11y__voice_over_close_language_menu": "Stäng undertexter och ljud",
  "player__a11y__voice_over_close_pause_ad_button": "Stäng annons",
  "player__a11y__voice_over_close_playback_speed_menu": "Stäng uppspelningshastighet",
  "player__a11y__voice_over_current_position": "Tid",
  "player__a11y__voice_over_enter_fullscreen_button": "Öppna helskärmsläge",
  "player__a11y__voice_over_exit_fullscreen_button": "Stäng helskärmsläge",
  "player__a11y__voice_over_go_to_live": "Gå till live",
  "player__a11y__voice_over_go_to_start": "Se från början",
  "player__a11y__voice_over_initial_playback_button": "Spela",
  "player__a11y__voice_over_loading_waiting_for_content": "Laddar, vänta",
  "player__a11y__voice_over_mute_button": "Ljud av",
  "player__a11y__voice_over_open_language_menu": "Öppna undertexter och ljud",
  "player__a11y__voice_over_open_playback_speed_menu": "Öppna uppspelningshastighet",
  "player__a11y__voice_over_open_share_menu_button": "Dela",
  "player__a11y__voice_over_open_voting_button": "Rösta",
  "player__a11y__voice_over_pause_button": "Pausa",
  "player__a11y__voice_over_play_button": "Spela",
  "player__a11y__voice_over_progress_bar": "{currentTime} av {totalTime}",
  "player__a11y__voice_over_refresh_page_button": "Ladda om sidan",
  "player__a11y__voice_over_seek_back_button": "Hoppar bakåt {seconds}s",
  "player__a11y__voice_over_seek_forward_button": "Hoppar fram {seconds}s",
  "player__a11y__voice_over_select_playback_speed": "Välj hastighet",
  "player__a11y__voice_over_start_cast_button": "Starta chromecast",
  "player__a11y__voice_over_stop_cast_button": "Sluta casta",
  "player__a11y__voice_over_time_remaining": "Tid kvar",
  "player__a11y__voice_over_unmute_button": "Ljud på",
  "player__a11y__voice_over_video_controls": "Videokontroller",
  "player__a11y__voice_over_visit_advertiser_button": "Besök annonsör",
  "player__a11y__voice_over_volume_slider": "Volym vertikal skjutreglage",
  "player__controls__play": "Play",
  "player__generic_action_disabled__message": "Denna funktion är tyvärr inte tillgänglig för detta program.",
  "player__pausead_information": "Ad. Press play to continue",
  "player__text_size__large": "Stor",
  "player__text_size__medium": "Mellan",
  "player__text_size__small": "Liten",
  "player__text_size__x_large": "Extra stor",
  "program_metadata__episode": "Avsnitt",
  "program_metadata__season": "Säsong",
  "quality__high": "Hög",
  "quality__low": "Låg",
  "quality__medium": "Medium",
  "quality__title": "Kvalité",
  "quality__unlimited": "Obegränsat",
  "refresh_page": "Ladda om sidan",
  "skip_intro": "Hoppa över intro",
  "skip_recap": "Hoppa över sammanfattning",
  "start_over__start_over": "Börja om",
  "start_over__start_over_shortened": "Början",
  "start_over__watch_live": "Titta live",
  "start_over__watch_live_shortened": "Live",
  "start_over_choice__continue_playing_live_counter": "Fortsätt spela live om {secondsLeft} sekunder",
  "start_over_choice__watch_from_beginning": "Se från början",
  "start_over_choice__watch_live": "Se live",
  "streaming__device_other": "Annan",
  "streaming__locations_title": "Streamar nu",
  "streaming__open_locations": "Detaljer om din uppspelning"
}
